namespace Areas {
    "use strict";

    export enum ContentType { Json, Form }

    export function sendRequest(url: string, data: string, method: string,
        callback: (any) => void = null, contentType: ContentType = ContentType.Json): JQueryXHR {

        const errorMessage = "Error in request - Contact IS department";

        let content = "application/json";
        if (contentType === ContentType.Form) {
            content = "application/x-www-form-urlencoded; charset=utf-8";
        }
        const defaultTimeOut = 4000;
        const redirectTimeOut = 2000;

        const toastrOptions = { timeOut: defaultTimeOut, positionClass: "toast-bottom-full-width", showMethod: "show" };

        toastr.info("Processing...", "", toastrOptions);

        return $.ajax({
            url: url,
            xhrFields: {
                withCredentials: true
            },
            method: method,
            contentType: content,
            data: data,
            success: (response: any) => {

                if (method === "DELETE") {
                    toastr.warning(response.msg, "", toastrOptions);
                } else {
                    toastr.success(response.msg, "", toastrOptions);
                }

                if (callback) {
                    callback(response.data);
                }

                if (response.url) {
                    setTimeout(() => { window.location.href = response.url; }, redirectTimeOut);
                }

            },
            error: (response) => {
                if (response.responseText) {
                    toastr.error(response.responseText, "Error", toastrOptions);
                } else {
                    toastr.error(errorMessage, "Error", toastrOptions);
                }
            }
        });
    }

}
